var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bb_logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 142 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M73.5,9.4L73.5,9.4l-0.2-0.3c-0.5-0.5-0.8-1.1-0.8-1.8c0-0.9,0.8-2,2.4-2c1.4,0,2.5,0.9,2.5,2.1         c0,1.4-1.4,2.1-1.4,2.2l1.1,1.1c0.2-0.3,0.3-0.7,0.4-1s0.1-0.5,0.5-0.3l0.9,0.3c0.3,0.1,0.2,0.4,0.2,0.6         c-0.3,0.9-0.8,1.5-0.8,1.6l1.1,1c0.2,0.1,0.3,0.3,0,0.6l-0.7,0.7c-0.1,0.1-0.4,0.2-0.6,0l-0.8-0.8c0,0-0.8,1-2.7,1         c-1.6,0-2.7-1.1-2.7-2.4C71.8,10.1,73.5,9.4,73.5,9.4z M74.7,12.7c1,0,1.3-0.6,1.3-0.6l-1.6-1.7c0,0-0.9,0.3-0.9,1.3         C73.5,12.2,74.1,12.7,74.7,12.7z M75.7,7.4c0-0.4-0.4-0.8-0.9-0.8c-0.5,0-0.7,0.3-0.7,0.6c0,0.4,0.2,0.6,0.6,1L75,8.5         C74.9,8.5,75.7,8.1,75.7,7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M36.6,12.5c1.5,0.7,1.5,2.3,1.5,2.3c0,3.2-3.3,3.3-4,3.3h-3.5c-0.2,0-0.3-0.1-0.3-0.3V7.2         c0-0.1,0.1-0.3,0.3-0.3h3.5c0,0,3.9-0.1,3.9,3.3C37.9,11.4,37.4,12.1,36.6,12.5z M32.6,11.4h1.5c0,0,1.4,0,1.4-1         c0-1.1-1.4-1.1-1.4-1.1h-1.5V11.4z M35.6,14.7c0-1.1-1.6-1-1.6-1h-1.5v2.1H34C34.7,15.8,35.6,15.6,35.6,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M50.3,12.6c0,2.8-1.8,5.7-5.5,5.7c-3.7,0-5.5-2.9-5.5-5.7s1.8-5.7,5.5-5.7         C48.5,6.9,50.3,9.7,50.3,12.6z M47.9,12.6c0-1.7-1-3.4-3-3.4s-3,1.7-3,3.4c0,1.7,1,3.4,3,3.4S47.9,14.3,47.9,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M54.8,9.3v2.2h4c0.2,0,0.3,0.1,0.3,0.3v1.7c0,0.1-0.1,0.3-0.3,0.3h-4V16h4.9         c0.2,0,0.4,0.1,0.4,0.3V18c0,0.1-0.1,0.3-0.4,0.3h-6.9c-0.2,0-0.3-0.1-0.3-0.3V7.3c0-0.1,0.1-0.3,0.3-0.3h6.9         c0.2,0,0.4,0.1,0.4,0.3V9c0,0.1-0.1,0.3-0.4,0.3H54.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M65,13.7h-0.8v4.1c0,0.1-0.1,0.3-0.4,0.3h-1.7c-0.2,0-0.3-0.1-0.3-0.3V7.3c0-0.1,0.1-0.3,0.3-0.3         h3.5c0.7,0,3.8,0,3.8,3.3c0,1.7-0.9,2.5-1.9,3c0.3,0.7,0.7,1.5,1,2.2l1,2.1c0.1,0.2,0,0.4-0.3,0.4h-1.9c-0.1,0-0.3-0.1-0.3-0.2         L65,13.7z M64.2,11.6h1.4c0.4,0,1.4-0.1,1.4-1.1s-1.1-1.1-1.4-1.1h-1.4V11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M88.6,12.5c1.5,0.7,1.5,2.3,1.5,2.3c0,3.2-3.3,3.3-4,3.3h-3.5c-0.2,0-0.3-0.1-0.3-0.3V7.2         c0-0.1,0.1-0.3,0.3-0.3h3.5c0,0,3.9-0.1,3.9,3.3C89.9,11.4,89.4,12.1,88.6,12.5z M84.6,11.4h1.5c0,0,1.4,0,1.4-1         c0-1.1-1.4-1.1-1.4-1.1h-1.5V11.4z M87.6,14.7c0-1.1-1.6-1-1.6-1h-1.5v2.1H86C86.7,15.8,87.6,15.6,87.6,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M91.8,14.5V7.4c0-0.1,0.1-0.3,0.3-0.3h1.7c0.2,0,0.3,0.1,0.3,0.3v7c0.1,0.9,0.9,1.5,1.8,1.5         s1.8-0.5,1.8-1.5V7.3c0-0.1,0.1-0.3,0.3-0.3h1.8c0.2,0,0.3,0.1,0.3,0.3v7.1c0,2.4-1.8,3.8-4.2,3.8C93.6,18.3,91.8,16.8,91.8,14.5         z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M112,17.8c0,0.1-0.1,0.3-0.3,0.3H110c-0.1,0-0.2,0-0.3-0.1l-4.6-6.6v6.5c0,0.1-0.1,0.3-0.3,0.3         h-1.7c-0.2,0-0.3-0.1-0.3-0.3V7.3c0-0.1,0.1-0.3,0.3-0.3h1.8c0.1,0,0.2,0,0.3,0.1l4.6,6.7V7.2c0-0.1,0.1-0.3,0.3-0.3h1.7         c0.2,0,0.3,0.1,0.3,0.3L112,17.8L112,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M116.5,7.1c2.7,0,6.4,0.6,6.4,5.5c0,4.7-3.7,5.5-6.4,5.5h-1.7c-0.2,0-0.3-0.1-0.3-0.3V7.3         c0-0.1,0.1-0.3,0.3-0.3h1.7V7.1z M116.9,15.9c1.3,0,3.7-0.3,3.7-3.3c0-2.5-1.4-3.3-3.4-3.3c-0.1,0-0.1,0-0.3,0         C116.9,9.3,116.9,15.9,116.9,15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M127.3,9.3v2.2h4c0.2,0,0.3,0.1,0.3,0.3v1.7c0,0.1-0.1,0.3-0.3,0.3h-4V16h4.9         c0.2,0,0.4,0.1,0.4,0.3V18c0,0.1-0.1,0.3-0.4,0.3h-6.9c-0.2,0-0.3-0.1-0.3-0.3V7.3c0-0.1,0.1-0.3,0.3-0.3h6.9         c0.2,0,0.4,0.1,0.4,0.3V9c0,0.1-0.1,0.3-0.4,0.3H127.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M137.5,13.7h-0.8v4.1c0,0.1-0.1,0.3-0.4,0.3h-1.7c-0.2,0-0.3-0.1-0.3-0.3V7.3         c0-0.1,0.1-0.3,0.3-0.3h3.5c0.7,0,3.8,0,3.8,3.3c0,1.7-0.9,2.5-1.9,3c0.3,0.7,0.7,1.5,1,2.2l1,2.1c0.1,0.2,0,0.4-0.3,0.4h-1.9         c-0.1,0-0.3-0.1-0.3-0.2L137.5,13.7z M136.7,11.6h1.4c0.4,0,1.4-0.1,1.4-1.1s-1.1-1.1-1.4-1.1h-1.4V11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M72.6,18.1h5.6c0.1,0,0.3-0.1,0.3-0.3v-1.7c0-0.1-0.1-0.3-0.3-0.3h-5.6c-0.1,0-0.3,0.1-0.3,0.3v1.7         C72.4,18,72.5,18.1,72.6,18.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M12.5,25C5.6,25,0,19.4,0,12.5S5.6,0,12.5,0s12.5,5.6,12.5,12.5S19.3,25,12.5,25z M12.5,1         C6.2,1,1,6.2,1,12.5S6.2,24,12.5,24s11.5-5.2,11.5-11.5S18.7,1,12.5,1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12,
    style: {
      fill: "#FFFFFF"
    },
    width: 12,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12,
    style: {
      fill: "#FFFFFF"
    },
    width: 6,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "4.4,3.7 21.3,20.6 20.6,21.3 3.6,4.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1.9,7.2 17.8,23.1 17.1,23.8 1.2,7.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 1.9,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 10.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12.5,
    style: {
      fill: "#FFFFFF"
    },
    width: 1,
    height: 10.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBb);
export default __webpack_public_path__ + "static/media/logo_bb.11aa2d4047114b19d1b9956565acf6b1.svg";
export { ForwardRef as ReactComponent };